import { render, staticRenderFns } from "./QuoteDetails.vue?vue&type=template&id=01ed9de8&"
import script from "./QuoteDetails.vue?vue&type=script&lang=js&"
export * from "./QuoteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports